export default __webpack_public_path__ + "static/media/lps.5af65385.svg";